import { render } from "./OrganPartsMobile.vue?vue&type=template&id=14386703&scoped=true&lang=html"
import script from "./OrganPartsMobile.vue?vue&type=script&lang=js"
export * from "./OrganPartsMobile.vue?vue&type=script&lang=js"

import "./OrganPartsMobile.vue?vue&type=style&index=0&id=14386703&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14386703"]])

export default __exports__